<template>
  <div v-show="!store.isEmptyOffers">
    <div
      v-show="showErrorNoSelected"
      class="grid-row grid-row_sm color-negative mb-8"
    >
      <div class="grid-col">
        <Icon iconName="icon-info-circle" className="icon-20" />
      </div>
      <div class="grid-col grid-col_full fs-14">Необходимо выбрать размер</div>
    </div>
    <div
      class="grid-row d-flex_wrap d-flex_md-nowrap grid-row_md grid-row_sm-sm"
    >
      <div class="grid-col grid-col_100 grid-col_md-50">
        <div
          v-if="
            isInBasket === false &&
            isServiceOrder === false &&
            isShippingRestriction === false &&
            isReserveOnly === false &&
            this.store.getSelectedOffer?.addition === true
          "
          class="btn btn_lg btn_px-sm border-radius-md fs-18 fw-medium w-100 fs-sm-14 btn_primary"
          :class="getButtonClassName()"
          @click="addToCart"
        >
          <Icon iconName="icon-shopping-cart" className="icon-24 d-md-none" />
          <span class="px-16 d-md-none">Добавить в корзину</span>
          <span class="d-none d-md-block">В корзину</span>
          <Icon iconName="icon-arrow-all-right" className="icon-24 d-md-none" />
        </div>

        <div
          v-if="
            isServiceOrder === true &&
            isCityPresence === true &&
            isShippingRestriction === false
          "
          class="btn btn_lg btn_px-sm border-radius-md fs-18 fw-medium w-100 fs-sm-14 btn_primary mt-8"
          :class="getButtonClassName()"
          :data-id="store.getSelectedOffer.id"
          :data-price="store.getSelectedOffer.price?.current_number"
          :data-service="getServiceOrder?.xml_id"
          :data-name="store.getSelectedProduct.name"
          @click="openSelection"
        >
          Записаться на подбор
        </div>

        <div
          v-if="
            isInBasket === true &&
            isServiceOrder === false &&
            isShippingRestriction === false &&
            isCollagen === false &&
            isReserveOnly === false
          "
          class="btn btn_lg btn_px-sm border-radius-md fs-18 fw-medium w-100 fs-sm-14 btn_primary"
          @click="redirectToCart"
        >
          Перейти в&nbsp;корзину
        </div>
      </div>

      <div class="grid-col grid-col_100 grid-col_md-50 pt-8 pt-md-0">
        <PopupOneClick v-if="isShippingRestriction === true" />

        <div
          v-if="canReserve"
          class="btn btn_lg btn_px-sm border-radius-md fs-18 fw-medium w-100 fs-sm-14 btn_primary-soft reserve_button"
          @click="openReserve"
        >
          <span class="d-md-none">Забрать в салоне через 15 минут</span>
          <span class="d-none d-md-block">Забрать в&nbsp;салоне</span>
        </div>
      </div>
    </div>
  </div>

  <teleport to="#product-element__popup-container-vue">
    <transition name="fade">
      <div class="popup d-flex_middle" v-if="store.errors.basket === true">
        <div class="popup__layout" @click="closePopup()"></div>
        <div
          class="popup__wrap p-16 p-md-0 scroll scroll_y w-100 active-move-down"
          v-bind:class="{ 'is-active': store.errors.basket }"
        >
          <div
            class="popup__block popup__block_sm bg-white border-radius-xl p-24 p-md-16 mx-auto"
          >
            <div class="grid-row d-flex_start grid-row_md">
              <div class="grid-col grid-col_full">
                <div class="fs-18 fw-medium">Ошибка</div>
                <div class="fs-14 mt-12">Товар отсутствует</div>
              </div>
              <div class="grid-col">
                <div
                  class="link text-grey-light hover-primary"
                  @click="closePopup()"
                >
                  <Icon iconName="icon-close" className="icon-24" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /popup__wrap -->
      </div>
    </transition>
  </teleport>
</template>

<script>
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { loadingProcess } from "@/pages/product_card/tools/loading";
import Icon from "@/pages/product_card/components/Icon/Icon.vue";
import PopupOneClick from "@/pages/product_card/components/Popups/PopupOneClick.vue";
import { mapActions, mapState } from "pinia";

export default {
  name: "BasketButton",
  props: {
    showOneClick: {
      type: Boolean,
      default: true,
    },
    showReserve: {
      type: Boolean,
      default: true,
    },
    showRecord: {
      type: Boolean,
      default: true,
    },
    buttonSize: {
      type: String,
      default: "lg",
    },
    buttonStyle: {
      type: String,
      default: "primary",
    },
  },
  components: { PopupOneClick, Icon },
  data() {
    return {
      isShow: false,
      isAnimate: false,
      isCityPresence: window.isCityPresenceApp,
      showErrorNoSelected: false,
    };
  },
  setup() {
    const store = useProductStore();

    return {
      store,
    };
  },
  mounted() {
    document.addEventListener("show-error-no-selected", () => {
      if (window.BX.browser.IsMobile()) {
        if (document.querySelector("#product-sizes")) {
          document
            .querySelector("#product-sizes")
            .scrollIntoView({ block: "center" });
        } else {
          document
            .querySelector("#product-params")
            .scrollIntoView({ block: "center" });
        }
      }

      this.showErrorNoSelected = true;
    });

    document.addEventListener("hidden-error-no-selected", () => {
      this.showErrorNoSelected = false;
    });
  },
  methods: {
    ...mapActions(useProductStore, ["addToCart", "isAllParamSelected"]),
    closePopup() {
      this.store.errors.basket = false;
    },
    loadingProcess,
    redirectToCart() {
      window.location.href = "/personal/cart/";
    },
    getButtonClassName() {
      return "btn btn_" + this.buttonSize + " btn_" + this.buttonStyle;
    },
    openSelection(ev) {
      if (!this.store.isAllParamSelected()) {
        document.dispatchEvent(new Event("check-selected-params"));
        document.dispatchEvent(new Event("show-error-no-selected"));

        return false;
      }

      window.openDoctorRecordFormList(ev.target);
    },
    openReserve() {
      if (!this.store.isAllParamSelected()) {
        document.dispatchEvent(new Event("check-selected-params"));
        document.dispatchEvent(new Event("show-error-no-selected"));

        return false;
      }

      window.fastorder = {
        offer: {
          ID: this.getSelectedOffer.id,
        },
      };

      if (!window.initYandexMap) {
        window.initYandexMap = true;
        window.addScript(window.ymapsSrc, function () {
          window.openReservePopup();
        });
      } else {
        window.openReservePopup();
      }
    },
  },
  computed: {
    ...mapState(useProductStore, [
      "isServiceOrder",
      "isCollagen",
      "isShippingRestriction",
      "getSelectedOffer",
      "getSelectedProduct",
      "isInBasket",
      "isReserveOnly",
      "canAddCart",
      "canReserve",
    ]),
    getServiceOrder() {
      return this.store.getSelectedProduct?.service;
    },
  },
};
</script>
